import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/siteInfo";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">
              {siteInfo.name}
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专业写真摄影作品欣赏与风格解析平台，为摄影爱好者提供高质量的白露写真作品参考。
            </p>
          </div>

          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                首页
              </Link>
              <Link to="/category/qingxin-xiezhen" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                作品欣赏
              </Link>
              <Link to="/category/paishe-jiqiao" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                拍摄技巧
              </Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">
              作品分类
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">
              联系我们
            </h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <span>邮箱：{siteInfo.contact.email}</span>
              <span>微信：{siteInfo.contact.wechat}</span>
              <span>微博：{siteInfo.contact.weibo}</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供摄影学习与交流参考
          </p>
        </div>
      </div>
    </footer>
  );
}